import Component from "./CourseFreeWrapperForFreeProgram";
export default Component;
